import Box from '@mui/material/Box';
import { ReactElement } from 'react';
import { Control, FieldErrors, FieldValues } from 'react-hook-form';
import classNames from 'classnames';

import DatePicker from '~/ui/components/inputs/DatePicker';
import RadioGroup from '~/ui/components/inputs/RadioGroup';
import Select from '~/ui/components/inputs/SelectWithoutAnimation';

import isStatusDone from '~/ui/pages/Visits/utils/isStatusDone';

import {
  testingStatusOptions,
  toxicologyResultOptions,
} from '~/ui/pages/Visits/constants/toxicologyOptions';
import { IToxicology } from '../AddVisit/types';

import styles from '../Form/Form.module.scss';

interface IToxicologyProps<TFieldValues extends FieldValues = FieldValues> {
  toxicology: IToxicology | null;
  control: Control<TFieldValues>;
  errors: FieldErrors;
}

const Toxicology = <TFieldValues extends FieldValues = FieldValues>({
  toxicology,
  control,
  errors,
}: IToxicologyProps<TFieldValues>): ReactElement => (
  <Box className={styles.column}>
    <RadioGroup
      name="toxicology.status"
      control={control}
      errors={errors}
      options={testingStatusOptions}
      label="Toxicology"
      size="small"
      className={styles.rowRadioGroup}
      unselectable
    />
    {isStatusDone(toxicology?.status) && (
      <Box className={classNames(styles.rowRadioGroup, styles.selectGroupWidth)}>
        <Select
          name="toxicology.result"
          control={control}
          errors={errors}
          label="Result"
          options={toxicologyResultOptions}
          hideSelectedOptions={false}
          openMenuOnFocus
        />
        <DatePicker
          name="toxicology.date"
          control={control}
          errors={errors}
          openTo="date"
          label="Result Date"
          maxDate={new Date().toISOString()}
        />
      </Box>
    )}
  </Box>
);

export default Toxicology;
